'use strict';

angular.module('licensure.services')
    .factory('TriggerCategories', ['$http', '$q', function ($http, $q) {
        return {
            get: function (trigger_configuration_id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/triggercategories', {
                        params: {
                            trigger_configuration_id: trigger_configuration_id
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id, attachNoCategory, licenseID) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/triggercategories/' + id, {
                        params: {
                            attachNoCategory: attachNoCategory,
                            licenseID: licenseID
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;